import z from 'zod'

export type Step =
  | 'overview'
  | 'hazards_and_scenarios'
  | 'capitals'
  | 'contextual_layers'
  | 'live_layers'
  | 'areas'
  | 'review_and_save'

// Note: individual types to make easily expandable in future
type ScenarioLayer = {
  id: string
  events: string[]
}

type CapitalLayer = {
  id: string
}

type ContextualLayer = {
  id: string
}

type LiveLayer = {
  id: string
}

type TemplateGroup = {
  name: string
  layers: (ScenarioLayer | CapitalLayer | LiveLayer)[]
}

type templateSet = {
  name: string
  groups: TemplateGroup
}

type Area = {
  area_type: string
  areas: string[]
}

export type Workspace = {
  name: string
  description: string
  tags: []
  access: 'private' | 'organisation'
  scenario_sets: templateSet[]
  capital_sets: templateSet[]
  contextual_layers: ContextualLayer[]
  live_groups: TemplateGroup[]
  areas: Area
}

export const WorkspaceOverviewSchema = z.object({
  name: z.string().min(1, 'Name is required').max(60, 'Name must be 40 characters or fewer'),
  description: z
    .string()
    .refine((val) => {
      const words = val.trim().split(/\s+/)
      return words.length <= 400
    })
    .optional(),
  visibility: z.enum(['private', 'organisation']),
})

export type WorkspaceOverviewFormData = z.infer<typeof WorkspaceOverviewSchema>
